import React from "react";
import { Modal } from "reactstrap";

import WhatsAppIcon from "./WhatsAppIcon";
import { promoCopy } from "./copy";
import {
  shouldShowOfferPopup,
  markOfferPopupShown,
  whatsAppLink,
  offerEndText,
  WHATSAPP_DISPLAY,
} from "../../constants/promo";
import "../../assets/css/promo.css";

const AlertIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M12 3a6 6 0 0 0-6 6c0 4-2 5-2 5h16s-2-1-2-5a6 6 0 0 0-6-6z" />
    <path d="M10.5 20a2 2 0 0 0 3 0" />
  </svg>
);

const WorkflowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <circle cx="5" cy="6" r="2.4" />
    <circle cx="19" cy="12" r="2.4" />
    <circle cx="5" cy="18" r="2.4" />
    <path d="M7.4 6h4.6a4 4 0 0 1 4 4v.4M7.4 18h4.6a4 4 0 0 0 4-4v-.4" />
  </svg>
);

const SparkIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 3l1.9 4.6L18.5 9.5 13.9 11.4 12 16l-1.9-4.6L5.5 9.5l4.6-1.9z" />
    <path d="M18 16.5l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z" />
  </svg>
);

/*
  Shows once per login session, and at most once every 12 hours per
  browser. Dismissing it restarts the same 12 hour clock, so nobody
  sees it more than twice a day.

  Language comes from OfferCampaign, not from the app locale.
*/
class OfferPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.timer = null;
  }

  componentDidMount() {
    if (!shouldShowOfferPopup()) {
      return;
    }

    // let the page paint first — it lands better a beat after login
    this.timer = setTimeout(() => {
      markOfferPopupShown();
      this.setState({ isOpen: true });
    }, 900);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  dismiss = () => {
    markOfferPopupShown();
    this.setState({ isOpen: false });
  };

  render() {
    const { lang, onToggleLang } = this.props;
    const t = promoCopy(lang);
    const rtl = t.dir === "rtl";

    return (
      <Modal
        isOpen={this.state.isOpen}
        toggle={this.dismiss}
        centered
        modalClassName="ctp-modal"
        backdropClassName="ctp-backdrop"
      >
        <div
          className={`ctp-pop ${rtl ? "ctp-rtl" : "ctp-ltr"}`}
          dir={t.dir}
          lang={lang}
        >
          <div className="ctp-aurora" aria-hidden="true">
            <span className="ctp-b1" />
            <span className="ctp-b2" />
            <span className="ctp-b3" />
          </div>

          <button
            type="button"
            className="ctp-close"
            onClick={this.dismiss}
            aria-label={t.closeLabel}
          >
            &#10005;
          </button>

          <button
            type="button"
            className="ctp-lang ctp-lang-pop"
            onClick={onToggleLang}
            title={t.switchTo}
          >
            {t.switchTo}
          </button>

          <span className="ctp-grab" aria-hidden="true" />

          <p className="ctp-kick">{t.kicker}</p>

          <h2 className="ctp-head">
            {t.head1} {t.head2}
            <br />
            <em>{t.head3}</em>
          </h2>

          <p className="ctp-sub">{t.sub}</p>

          <ul className="ctp-bens">
            <li>
              <AlertIcon />
              {t.benefit1}
            </li>
            <li>
              <WorkflowIcon />
              {t.benefit2}
            </li>
            <li>
              <SparkIcon />
              {t.benefit3}
            </li>
          </ul>

          <div className="ctp-price">
            <span className="ctp-from">{t.from}</span>
            <span className="ctp-amt">{t.price}</span>
            <span className="ctp-per">{t.period}</span>
          </div>

          <a
            className="ctp-wa"
            href={whatsAppLink(lang)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={this.dismiss}
          >
            <WhatsAppIcon />
            {t.cta}{" "}
            {/* dir=ltr so the number is not reordered inside Arabic text */}
            <span className="ctp-wa-num" dir="ltr">
              {WHATSAPP_DISPLAY}
            </span>
          </a>

          <button type="button" className="ctp-later" onClick={this.dismiss}>
            {t.later}
          </button>

          <p className="ctp-valid">
            {t.validPrefix} {offerEndText(lang)}
          </p>
        </div>
      </Modal>
    );
  }
}

export default OfferPopup;
